import { createSlice } from "@reduxjs/toolkit";
import { getProfileData, updateProfile } from "../thunk";
import { logout } from "../slices";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    clearProfile: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfileData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProfileData.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.success) {
          state.data = action.payload.data;
          state.error = null;
        } else {
          state.error = action.payload?.message || "Failed to fetch profile";
        }
      })
      .addCase(getProfileData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch profile";
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        if (action.payload?.success) {
          const updated = action.payload.data;
          if (updated && typeof updated === "object") {
            state.data = { ...(state.data || {}), ...updated };
          }
        }
      })
      .addCase(logout, () => initialState);
  },
});

export const { clearProfile } = profileSlice.actions;
export default profileSlice.reducer;
